import { U340X_KPI_MIN_MONTHS } from '../types/u340xKpiTypes';

export function u340xClampMonths(
  months: number,
  maxMonths: number,
  minMonths: number = U340X_KPI_MIN_MONTHS,
): number {
  if (!Number.isFinite(months)) {
    return minMonths;
  }
  const rounded = Math.trunc(months);
  return Math.min(maxMonths, Math.max(minMonths, rounded));
}

export function u340xIsValidMonths(
  months: number,
  maxMonths: number,
  minMonths: number = U340X_KPI_MIN_MONTHS,
): boolean {
  if (!Number.isFinite(months) || !Number.isInteger(months)) {
    return false;
  }
  return months >= minMonths && months <= maxMonths;
}
